(function () {
  function initCarousel(root) {
    if (root.dataset.aiInit) return;
    root.dataset.aiInit = '1';
    var track = root.querySelector('[data-ai-track]');
    if (!track) return;
    track.classList.add('ai-scroll');
    var dotsWrap = root.querySelector('[data-ai-dots]');
    var arrowsWrap = root.querySelector('[data-ai-arrows]');
    var dotsClass = root.getAttribute('data-ai-dots-class') || '';
    var arrowClass = root.getAttribute('data-ai-arrow-class') || '';
    var prev, next, ul;

    function slides() {
      return Array.prototype.filter.call(track.children, function (s) { return !s.hidden && s.offsetParent !== null; });
    }
    function perView() {
      var s = slides();
      if (!s.length) return 1;
      var w = s[s.length > 1 ? 1 : 0].getBoundingClientRect().width || 1;
      return Math.max(1, Math.floor((track.clientWidth + 2) / w));
    }
    function pageCount() {
      var s = slides();
      return s.length ? Math.max(1, s.length - perView() + 1) : 0;
    }
    function current() {
      var s = slides();
      if (!s.length) return 0;
      var origin = s[0].offsetLeft, x = track.scrollLeft, best = 0, bd = Infinity;
      s.forEach(function (el, i) { var d = Math.abs(el.offsetLeft - origin - x); if (d < bd) { bd = d; best = i; } });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = pageCount() - 1;
      return Math.min(best, pageCount() - 1);
    }
    function go(i) {
      var s = slides();
      if (!s[i]) return;
      track.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: 'smooth' });
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var n = pageCount();
      if (n < 2) return;
      ul = document.createElement('ul');
      if (dotsClass) ul.className = dotsClass;
      for (var i = 0; i < n; i++) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = String(i + 1);
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + n);
        (function (k) { b.addEventListener('click', function () { go(k); }); })(i);
        li.appendChild(b);
        ul.appendChild(li);
      }
      dotsWrap.appendChild(ul);
    }
    function buildArrows() {
      if (!arrowsWrap || !arrowClass) return;
      arrowsWrap.innerHTML = '';
      prev = document.createElement('button');
      next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = arrowClass + ' ' + arrowClass + '--prev slick-prev';
      next.className = arrowClass + ' ' + arrowClass + '--next slick-next';
      prev.setAttribute('aria-label', 'Previous');
      next.setAttribute('aria-label', 'Next');
      prev.innerHTML = '&larr;';
      next.innerHTML = '&rarr;';
      prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
      next.addEventListener('click', function () { go(Math.min(pageCount() - 1, current() + 1)); });
      arrowsWrap.appendChild(prev);
      arrowsWrap.appendChild(next);
    }
    function update() {
      var c = current(), n = pageCount();
      if (ul) Array.prototype.forEach.call(ul.children, function (li, i) {
        li.classList.toggle('slick-active', i === c);
        li.firstChild.toggleAttribute('aria-current', i === c);
      });
      if (prev) prev.classList.toggle('slick-disabled', c <= 0);
      if (next) next.classList.toggle('slick-disabled', c >= n - 1);
    }
    function rebuild() { buildDots(); update(); }

    var filters = root.querySelectorAll('[data-ai-filter]');
    Array.prototype.forEach.call(filters, function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-ai-filter');
        Array.prototype.forEach.call(filters, function (b) { b.classList.toggle('is-active', b === btn); });
        Array.prototype.forEach.call(track.children, function (s) {
          s.hidden = (s.getAttribute('data-ai-group') || '') !== val;
        });
        track.scrollLeft = 0;
        rebuild();
      });
    });
    if (filters.length) filters[0].click();

    buildArrows();
    rebuild();
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(rebuild, 150); });
  }
  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ai-carousel]'), initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
